<template>
  <public-page :background="default_background">
    <v-row
      align="center"
      class="white--text mx-auto fill-height"
      justify="center"
    >
      <v-spacer></v-spacer>
      <v-col class="text-center" cols="12">
        <v-card class="login-card mx-auto pa-8" max-width="420" elevation="8" rounded="lg" dark>
          <v-img
            :src="require('@/assets/camceadhub-logo-dark.png')"
            contain
            max-height="120"
            :alt="intro_text"
            class="mx-auto"
          ></v-img>
          <div class="login-heading mt-4 mb-6">
            Welcome to the CAMCEAD Cloud-Based Analysis Platform
          </div>
          <v-btn
            outlined
            rounded
            large
            color="grey lighten-1"
            @click="$router.push({ name: 'SignIn' }, () => {})"
          >
            <v-icon left> mdi-login </v-icon>
            Login</v-btn
          >
          <v-divider class="my-6 login-divider"></v-divider>
          <a href="https://www.cam.ac.uk/" target="_blank" rel="noopener">
            <v-img
              :src="require('@/assets/university-of-cambridge-logo.png')"
              contain
              max-height="36"
              max-width="200"
              class="mx-auto"
            ></v-img>
          </a>
          <a
            href="https://www.ast.cam.ac.uk/"
            target="_blank"
            rel="noopener"
            class="login-ioa-link d-block mt-2"
            >Institute of Astronomy</a
          >
        </v-card>
      </v-col>

      <v-col style="margin-top: 2em" class="white--text text-center" cols="12">
        <v-btn
          class="align-self-end white--text scroll-down-btn"
          fab
          outlined
          @click="$vuetify.goTo('#platform')"
        >
          <v-icon>mdi-chevron-double-down</v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <v-spacer></v-spacer>
    <template #extra>
      <v-row justify="center" class="pt-8 light">
        <v-col cols="10">
          <v-card id="platform" flat light class="rounded-0">
            <v-card-title
              class="justify-center text-h4"
              style="text-transform: capitalize"
              >Analysis platform</v-card-title
            >
            <v-card-text style="margin-top: 50px">
              <p>
                CAMCEADhub is a set of tools that allow you to:
              </p>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row justify="center" class="light">
        <v-col cols="10">
          <v-card light flat class="rounded-0">
            <v-row>
              <v-col cols="12" md="4" sm="12">
                <v-card-title>Upload data</v-card-title>
                <v-card-text>
                  <p>
                    Upload your data to the platform and start analysing it.
                  </p>
                  <p>
                    Using the S3 protocol connect to your storage remotely and
                    upload data using the command line or one of the multiple
                    transfer GUIs that support S3.
                  </p>
                </v-card-text>
              </v-col>
              <v-col cols="12" md="8" sm="12">
                <v-img
                  max-width="600"
                  :src="require('@/assets/jupyter.png')"
                ></v-img>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
      <v-row justify="center" class="light">
        <v-col cols="6">
          <v-divider class="divider divider-transparent"></v-divider>
        </v-col>
      </v-row>
      <!-- Jupyter -->
      <v-row justify="center" class="light">
        <v-col cols="10">
          <v-card light flat class="rounded-0">
            <v-row>
              <v-col cols="12" md="4" sm="12">
                <v-card-title>Jupyter Notebooks</v-card-title>
                <v-card-text>
                  <p>Use notebooks.</p>
                  <p></p>
                </v-card-text>
              </v-col>
              <v-col cols="12" md="8" sm="12">
                <v-img
                  max-width="600"
                  :src="require('@/assets/jupyter.png')"
                ></v-img>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
      <v-row justify="center" class="light">
        <v-col cols="6">
          <v-divider class="divider divider-transparent"></v-divider>
        </v-col>
      </v-row>
      <!-- Remote Desktop -->
      <v-row justify="center" class="light">
        <v-col cols="10">
          <v-card light flat class="rounded-0">
            <v-row>
              <v-col cols="12" md="4" sm="12">
                <v-card-title>Remote Desktops</v-card-title>
                <v-card-text>
                  <p>Use notebooks.</p>
                  <p></p>
                </v-card-text>
              </v-col>
              <v-col cols="12" md="8" sm="12">
                <v-img
                  max-width="600"
                  :src="require('@/assets/desktop.png')"
                ></v-img>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
      <v-row justify="center" class="light">
        <v-col cols="6">
          <v-divider class="divider divider-transparent"></v-divider>
        </v-col>
      </v-row>
      <!-- Batch jobs -->
      <v-row justify="center" class="light">
        <v-col cols="10">
          <v-card light flat class="rounded-0">
            <v-row>
              <v-col cols="12" md="4" sm="12">
                <v-card-title>Batch jobs</v-card-title>
                <v-card-text>
                  <p>Use notebooks.</p>
                  <p></p>
                </v-card-text>
              </v-col>
              <v-col cols="12" md="8" sm="12">
                <v-img
                  max-width="600"
                  :src="require('@/assets/jobs2.png')"
                ></v-img>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
      <v-row justify="center" class="light">
        <v-col cols="6">
          <v-divider class="divider divider-transparent"></v-divider>
        </v-col>
      </v-row>
      <!-- RStudio -->
      <v-row justify="center" class="light">
        <v-col cols="10">
          <v-card light flat class="rounded-0">
            <v-row>
              <v-col cols="12" md="4" sm="12">
                <v-card-title>RStudio IDE</v-card-title>
                <v-card-text>
                  <p>Use notebooks.</p>
                  <p></p>
                </v-card-text>
              </v-col>
              <v-col cols="12" md="8" sm="12">
                <v-img
                  max-width="600"
                  :src="require('@/assets/rstudio.png')"
                ></v-img>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
      <v-row justify="center" class="light">
        <v-col cols="6">
          <v-divider class="divider divider-transparent"></v-divider>
        </v-col>
      </v-row>
      <!-- Visual Studio Code -->
      <v-row justify="center" class="light">
        <v-col cols="10">
          <v-card light flat class="rounded-0">
            <v-row>
              <v-col cols="12" md="4" sm="12">
                <v-card-title>Visual Studio Code</v-card-title>
                <v-card-text>
                  <p>Use notebooks.</p>
                  <p></p>
                </v-card-text>
              </v-col>
              <v-col cols="12" md="8" sm="12">
                <v-img
                  max-width="600"
                  :src="require('@/assets/vscode.png')"
                ></v-img>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>

      <v-row justify="center" class="light">
        <v-col cols="6">
          <v-divider class="divider divider-transparent"></v-divider>
        </v-col>
      </v-row>

      <v-row class="light">
        <v-col cols="12">
          <v-card light flat class="rounded-0">
            <v-card-title
              class="justify-center text-h4"
              style="text-transform: capitalize"
              >Technology</v-card-title
            >
            <v-card-text style="margin-top: 50px">
              <v-row align="center" justify="center">
                <v-col cols="10" sm="5" md="2">
                  <v-card flat>
                    <v-img
                      height="100"
                      contain
                      :src="require('@/assets/logos/kubernetes.png')"
                    ></v-img>
                    <v-card-title class="justify-center"
                      >Kubernetes</v-card-title
                    >
                  </v-card>
                </v-col>
                <v-col cols="10" sm="5" md="2">
                  <v-card flat>
                    <v-img
                      height="100"
                      contain
                      :src="require('@/assets/logos/jupyter.png')"
                    ></v-img>
                    <v-card-title class="justify-center">Jupyter</v-card-title>
                  </v-card>
                </v-col>
                <v-col cols="10" sm="5" md="2">
                  <v-card flat>
                    <v-img
                      height="100"
                      contain
                      :src="require('@/assets/logos/python.png')"
                    ></v-img>
                    <v-card-title class="justify-center">Python</v-card-title>
                  </v-card>
                </v-col>
                <v-col cols="10" sm="5" md="2">
                  <v-card flat>
                    <v-img
                      height="100"
                      contain
                      :src="require('@/assets/logos/Rlogo.png')"
                    ></v-img>
                    <v-card-title class="justify-center">R</v-card-title>
                  </v-card>
                </v-col>
              </v-row>
              <v-row align="center" justify="center">
                <v-col cols="10" sm="5" md="2">
                  <v-card flat>
                    <v-img
                      height="100"
                      contain
                      :src="require('@/assets/logos/docker.png')"
                    ></v-img>
                    <v-card-title class="justify-center">Docker</v-card-title>
                  </v-card>
                </v-col>
                <v-col cols="10" sm="5" md="2">
                  <v-card flat>
                    <v-img
                      height="100"
                      contain
                      :src="require('@/assets/logos/minio.png')"
                    ></v-img>
                    <v-card-title class="justify-center">Minio</v-card-title>
                  </v-card>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <div class="skew-c">
          <v-col cols="12" class="colour-block">
            <v-col cols="10" class="mx-auto">
              <h1>ABOUT</h1>
              <p>
                CAMCEADhub is CamCEAD's cloud-based scientific
                analysis platform for CASU users, giving researchers
                on-demand computational resources and streamlined access to
                data without needing to manage their own infrastructure. It
                provides Jupyter, RStudio and VS Code environments, remote
                desktop access, and S3-compatible data storage, running on
                IRIS &mdash; the UK's e-Infrastructure for Research and
                Innovation for STFC.
              </p>
              <p>
                Access is by registration and administrator approval. Once
                logged in, your dashboard shows a summary of storage usage,
                running Jupyter servers and job status, with links to every
                part of the platform.
              </p>
            </v-col>
          </v-col>
        </div>
      </v-row>
    </template>
  </public-page>
</template>

<script>
import PublicPage from "@/components/PublicPage";

export default {
  name: "HomeView",
  components: {
    PublicPage,
  },
  data: () => ({}),
  computed: {
    intro_text() {
      return process.env.VUE_APP_TITLE;
    },
    default_background() {
      return process.env.VUE_APP_DEFAULT_BACKGROUND;
    },
  },
};
</script>

<style>
.login-card.v-card {
  background-color: #101014 !important;
}

/* The outlined white scroll-down button had no backdrop, so it vanished
   against bright parts of the nebula background - give it a translucent
   dark fill and shadow so it stays visible regardless of what's behind it. */
.scroll-down-btn.v-btn {
  background-color: rgba(0, 0, 0, 0.35) !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.5) !important;
}

.login-heading {
  color: #bdbdbd;
  font-size: 1.1rem;
  font-weight: 700;
  line-height: 1.4;
}

.login-divider.v-divider {
  border-color: rgba(255, 255, 255, 0.2) !important;
}

.login-ioa-link {
  color: #9e9e9e !important;
  font-size: 13px;
  text-decoration: none;
}

.login-ioa-link:hover {
  text-decoration: underline;
}

.light {
  background-color: #fff !important;
}

.divider {
  position: relative;
  /* margin-top: 90px; */
  height: 1px;
  margin: 2em 0;
}

.divider-transparent:before {
  content: "";
  position: absolute;
  top: 0;
  left: 5%;
  right: 5%;
  width: 90%;
  height: 1px;
  background-image: linear-gradient(
    to right,
    transparent,
    rgb(48, 49, 51),
    transparent
  );
}

/*------------------*/
/*  SKEW CLOCKWISE  */
/*------------------*/
.skew-cc {
  width: 100%;
  height: 100px;
  position: absolute;
  left: 0px;
  background: linear-gradient(to right bottom, #823a9c 49%, #fff 50%),
    linear-gradient(-50deg, #ffffff 16px, #000 0);
}

/*-------------------------*/
/* SKEW COUNTER CLOCKWISE  */
/*-------------------------*/
.skew-c {
  width: 100%;
  height: 100px;
  position: absolute;
  left: 0px;
  background: linear-gradient(to left bottom, #fff 49%, #823a9c 50%);
}

.colour-block {
  background: #823a9c;
  /* width: 60%; */
  /* padding: 7% 20% 10% 20%; */
  margin-top: 100px;
  color: #fff;
}
.white-block {
  background: #fff;
  width: 60%;
  padding: 7% 20% 10% 20%;
  color: #823a9c;
}
</style>